<template>

    <div class="modal attendance-modal fade" id="archivedAnnouncementsModal" tabindex="-1" aria-labelledby="archivedAnnouncementsModal" aria-hidden="true" style="z-index:9999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Gearchiveerde mededelingen</p>
                    </div>
                    <button v-on:click="hideModal()" type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body pt-3 pb-4 px-4">

                    <div v-if="archivedAnnouncements.length === 0" class="text-center py-4">
                        <p>Geen gearchiveerde mededelingen gevonden.</p>
                    </div>

                    <div v-else class="messages">
                        <div
                            v-for="announcement in archivedAnnouncements" :key="announcement.id"
                            class="message"
                        >
                            <div class="content hasBeenRead">
                                <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                    <p class="sender">
                                        {{ announcement.title }}
                                    </p>
                                    <span class="date ms-sm-auto">
                                        {{ announcement.time_diff }}
                                    </span>
                                </div>
                                <div>
                                    <p v-html="announcement.description" class="text-sm text-lightgrey mb-0"></p>
                                </div>
                            </div>
                            <div class="actions">
                                <span v-on:click="resetAnnouncement(announcement)" role="button">
                                    <i class="fa fa-recycle"></i>
                                </span>
                                <span v-on:click="deleteAnnouncement(announcement)" role="button">
                                    <i class="fa fa-trash-o"></i>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'announcement-archived-modal',
    data() {
        return {
            archivedAnnouncements: [{
                key: {
                    id: '',
                    title: '',
                    description: '',
                    published: '',
                    date_from: '',
                    date_till: '',
                    time_diff: '',
                    roles: '',
                    viewed_at: '',
                },
            }],
            loading: true
        }
    },
    methods: {
        getArchivedAnnouncements() {
            this.loading = true;
            axios.get('api/get-archived-announcements')
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.archivedAnnouncements = response.data.announcements || [];

                    this.loading = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de gearchiveerde gesprekken.", "error");
                    this.loading = false;
                });
        },
        resetAnnouncement(announcement) {
            let parent = this;

            this.$swal({
                title: "Mededeling terugzetten. Weet je het zeker?",
                text: "",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, terugzetten",
                cancelButtonText: "Annuleren",
            }).then(
                function (callBack) {
                    if (callBack.isConfirmed) {
                        axios.post('api/reset-announcement', {
                            announcementId: announcement.id,
                        })
                            .then(response => {
                                if (response.data.status === 422) {
                                    throw [true, response.data.message];
                                }
                                parent.getArchivedAnnouncements();
                                parent.refetchParentMessages();
                            })
                            .catch(e => {
                                parent.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van het gesprek.", "error");
                            });
                    }
                }
            );
        },
        deleteAnnouncement(announcement) {
            let parent = this;

            this.$swal({
                title: "Mededeling verwijderen. Weet je het zeker?",
                text: "Deze actie kan niet ongedaan gemaakt worden.",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, verwijderen",
                cancelButtonText: "Annuleren",
            }).then(
                (callBack) => {
                    if (callBack.isConfirmed) {
                        axios.delete('api/delete-announcement/'+announcement.id)
                            .then(response => {
                                if (response.data.status === 422) {
                                    throw [true, response.data.message];
                                }

                                parent.getArchivedAnnouncements();
                                parent.refetchParentMessages();
                            })
                            .catch(e => {
                                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van de mededeling.", "error");
                            });
                    }
                }
            );
        },
        refetchParentMessages() {
            EventBus.$emit('refetchAnnouncements');
        },
        hideModal() {
            EventBus.$emit('refetchAnnouncements');
            this.modal.hide();
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('archivedAnnouncementsModal'));

        EventBus.$on('openArchivedAnnouncementsModal', () => {
            this.getArchivedAnnouncements();
            this.modal.show();
        });
    }
}
</script>

<style>

.swal2-container {
    z-index: 9999;
}
</style>
